/* eslint-disable jira/import-whitelist -- route resource manually preloads Relay query data for JQLBuilderWithAI */
import { loadQuery, type PreloadedQuery } from 'react-relay';
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import { RELAY_RESOURCE_TYPE } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { QueryPromisesMap } from '@atlassian/relay-query-promises';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import queuesJqlBuilderAiRelayQuery, {
	type queuesJqlBuilderAiQueryRelayResourceQuery as QueryType,
} from './__generated__/queuesJqlBuilderAiQueryRelayResourceQuery.graphql';

export const RESOURCE_TYPE_QUEUES_JQL_BUILDER_AI_RELAY = 'queues-jql-builder-ai-relay';

/**
 * Relay resource for loading AI query data for JQLBuilderWithAI in queues.
 * Spreads JQLBuilderWithAIEntryPoint fragment.
 */
export const queuesJqlBuilderAiQueryRelayResource: RouteResource<
	PreloadedQuery<QueryType, Record<string, unknown>>
> = createResource<PreloadedQuery<QueryType>>({
	type: `${RELAY_RESOURCE_TYPE}_${RESOURCE_TYPE_QUEUES_JQL_BUILDER_AI_RELAY}`,
	getKey: () => RESOURCE_TYPE_QUEUES_JQL_BUILDER_AI_RELAY,
	getData: async (routerContext, { tenantContext }) => {
		const queryReference = loadQuery<QueryType>(
			getRelayEnvironment(),
			queuesJqlBuilderAiRelayQuery,
			{
				cloudId: tenantContext.cloudId,
				atlassianIntelligenceProductFeature: 'NATURAL_LANGUAGE_TO_JQL',
			},
			{
				fetchPolicy: 'store-or-network',
			},
		);

		const queryPromise =
			queryReference.id != null ? QueryPromisesMap.get(queryReference.id) : undefined;
		if (queryPromise != null) {
			await queryPromise;
		}

		return queryReference;
	},
	maxAge: 0,
});
